/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutTransitionRequest
 */
export interface CarveOutTransitionRequest {
    /**
     * 
     * @type {string}
     * @memberof CarveOutTransitionRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the CarveOutTransitionRequest interface.
 */
export function instanceOfCarveOutTransitionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CarveOutTransitionRequestFromJSON(json: any): CarveOutTransitionRequest {
    return CarveOutTransitionRequestFromJSONTyped(json, false);
}

export function CarveOutTransitionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutTransitionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function CarveOutTransitionRequestToJSON(value?: CarveOutTransitionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reason': value.reason,
    };
}

